import React from 'react';
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { skills, experiences } from "../constants";
import { FaLinkedin } from 'react-icons/fa';
import "react-vertical-timeline-component/style.min.css";
import '../styles/AboutTwo.scss';

const AboutTwo = () => {
  return (
    <section className="about-container">
      <h1 className="headline">
        Hello, I'm <span className="gradient-name">Estelo</span>
      </h1>

      <div className="about-intro">
        <p>
          I have hands-on experience with a diverse range of software technologies, including domain management through Namecheap, e-commerce development with Shopify, and UI/UX design using Figma. My technical skill set includes HTML, CSS, JavaScript, and React, along with leveraging AI tools to explore innovative, efficient solutions. I work in development environments like Replit and Visual Studio Code, manage code and collaboration via GitHub, and deploy responsive websites using Netlify.
          This portfolio was built entirely from scratch with React, styled and developed in VS Code, and version-controlled through GitHub. It showcases not only my growing skill set but also my passion for continuous learning, creativity, and a hands-on approach to problem solving.
        </p>
        {/* <p>
          Building on the skills I gained through the Google UX Certificate and currently taking the "Master Figma" course from figmatraining.com to expand my UX knowledge.
          I'm eager to bring my creativity and dedication to my next opportunity by designing meaningful, impactful solutions.
        </p> */}
        <a
          href="https://www.linkedin.com/in/estelo-abellanosa-83a335186/"
          className="linkedin-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin /> Connect on LinkedIn
        </a>
      </div>

      <div className="skills-section">
        {/* <h3 className="subheading">My Skills</h3> */}
        <div className="skills-wrapper">
          {skills.map((skills, index) => (
            <div className="skills-container" key={index}>
              <p className="skills-name">{skills.name}</p>
              <img src={skills.imageUrl} alt={skills.name} />
              <p className="skills-desc-one">{skills.descOne}</p>
              <p className="skills-desc-two">{skills.descTwo}</p>
              <p className="skills-desc-three">{skills.descThree}</p>
            </div>
          ))}
        </div>
      </div>

      {/* <div className="experience-section">
        <h3 className="subheading">Work Experience</h3>
        <p className="experience-intro">
        My professional background spans quality control, inventory management, and technical support. While not a traditional path, these roles have strengthened my adaptability, problem-solving skills, and self-discipline. My transition into front-end development and UX design stems from a genuine passion for creating meaningful digital experiences that solve real-world problems.
        </p>

        <VerticalTimeline>
          {experiences.map((experience, index) => (
            <VerticalTimelineElement
              key={experience.company_name + index}
              date={experience.date}
              iconStyle={{ background: experience.iconBg }}
              icon={
                <div className="icon-wrapper">
                </div>
              }
              contentStyle={{
                borderBottom: `8px solid ${experience.iconBg}`,
                boxShadow: 'none',
              }}
            >
              <div>
                <h3 className="experience-title">{experience.title}</h3>
                <p className="experience-company">{experience.company_name}</p>
              </div>

              <ul className="experience-points">
                {experience.points.map((point, i) => (
                  <li key={i} className="experience-point">
                    {point}
                  </li>
                ))}
              </ul>
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </div> */}

      <hr className="divider" />
    </section>
  );
};

export default AboutTwo;
